export const SET_USER = "SET_USER"
export const SET_CATEGORY = "SET_CATEGORY"
export const SET_SERIES = "SET_SERIES"
export const SET_PARTS = "SET_PARTS" 
export const ADD_IMAGE = "ADD_IMAGE"
export const SET_TAXES = "SET_TAXES"
export const SET_COUPONS = "SET_COUPONS"
export const SET_GODOWN = "SET_GODOWN"
export const SET_LOCATION = "SET_LOCATION"
export const SET_ADD_CATEGORY = "SET_ADD_CATEGORY"
export const SET_ADD_SERIES = "SET_ADD_SERIES"
export const SET_ADD_PART = "SET_ADD_PART"
export const SET_ACTIVE_CATEGORY = "SET_ACTIVE_CATEGORY"
export const SET_ACTIVE_SERIES = "SET_ACTIVE_SERIES"
export const SET_ACTIVE_PART = "SET_ACTIVE_PART"
export const SET_ADD_PARTNER = "SET_ADD_PARTNER"
export const SET_PARTNERS = "SET_PARTNERS"
export const SET_ACTIVE_PARTNER = "SET_ACTIVE_PARTNER"
export const SET_PARTNER_REQUESTS = "SET_PARTNER_REQUESTS"
export const SET_ACTIVE_PARTNER_REQUEST = "SET_ACTIVE_PARTNER_REQUEST"
export const SET_APPUSERS = "SET_APPUSERS"
export const SET_ACTIVE_APPUSER = "SET_ACTIVE_APPUSER"